// extracted by mini-css-extract-plugin
export default {"layout":"main-layout_layout__CTrMG","spinWrapper":"main-layout_spinWrapper__QY95Z","spin":"main-layout_spin__hC6Qg"};